import {CommonService} from '../../services/common.service';
import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ReplaySubject, Subject} from 'rxjs';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {UsersService} from '../../services/users.service';

@Component({
  selector: 'app-user-basic',
  templateUrl: './user-basic.component.html'
})
export class UserBasicComponent implements OnInit {
  @Input() mode: string;
  @Input() roles: any[];
  @Input() salesGroups: any[];
  @Input() divisions: any[];
  @Input() regions: any;
  // tslint:disable-next-line:variable-name
  @Input() hq_ids: any;

  @Input() userBasicForm: FormGroup;
  @Input() users: any[];
  @Input() hasChildren: boolean;

  public filteredRoles: ReplaySubject<any[]>;
  public filteredSalesGroups: ReplaySubject<any[]>;
  public filteredRegions: ReplaySubject<any[]>;
  public filteredHQs: ReplaySubject<any[]>;
  public filteredUsers: ReplaySubject<any[]>;
  public filteredDivisions: ReplaySubject<any[]>;
  public onDestroy: Subject<void>;

  public rolesFilterControl: FormControl;
  public salesGroupsFilterControl: FormControl;
  public regionsFilterControl: FormControl;
  public hqsFilterControl: FormControl;
  public divisionsFilterControl: FormControl;
  public usersFilterControl: FormControl;
  formFieldTitle: string;
  technicalManagers: any = [];
  initialized: boolean;
  deviceIdHasError: boolean;

  constructor(public commonService: CommonService,
              private toastMessagesService: ToastMessagesService,
              public usersService: UsersService) {
    this.filteredRoles = new ReplaySubject<any[]>(1);

    this.filteredSalesGroups = new ReplaySubject<any[]>(1);

    this.filteredDivisions = new ReplaySubject<any[]>(1);

    this.filteredUsers = new ReplaySubject<any[]>(1);
    this.filteredRegions = new ReplaySubject<any[]>(1);
    this.filteredHQs = new ReplaySubject<any[]>(1);

    this.onDestroy = new Subject<void>();

    this.rolesFilterControl = new FormControl();

    this.salesGroupsFilterControl = new FormControl();
    this.divisionsFilterControl = new FormControl();

    this.usersFilterControl = new FormControl();
    this.regionsFilterControl = new FormControl();
    this.hqsFilterControl = new FormControl();

    this.formFieldTitle = 'Αντιπρόσωπος (*)';
    this.initialized = false;
    this.deviceIdHasError = false;
  }

  async fetchRegions() {
    this.regions = await this.usersService.fetchRegions();
  }

  async fetchHQs() {
    this.hq_ids = await this.usersService.fetchHeadQuarters();
  }

  public async ngOnInit(): Promise<any> {
    await this.fetchHQs();
    if (this.mode === 'create') {
      await this.fetchRegions();
      let index = this.roles.findIndex(role => role.id === 4);
      this.roles.splice(index, 1);
      index = this.roles.findIndex(role => role.id === 5);
      this.roles.splice(index, 1);
      index = this.roles.findIndex(role => role.id === 13);
      this.roles.splice(index, 1);
      // index = this.roles.findIndex(role => role.id === 14);
      // this.roles.splice(index, 1);
    } else {
      if (this.userBasicForm.controls.role.value.id !== 13 && this.userBasicForm.controls.role.value.id !== 14) {
        let index = this.roles.findIndex(role => role.id === 4);
        this.roles.splice(index, 1);
        index = this.roles.findIndex(role => role.id === 5);
        this.roles.splice(index, 1);
        index = this.roles.findIndex(role => role.id === 13);
        this.roles.splice(index, 1);
        // index = this.roles.findIndex(role => role.id === 14);
        // this.roles.splice(index, 1);
      }
    }

    this.regions.forEach(region => region.id = region.id.toString());
    this.hq_ids.forEach(hq => hq.id = hq.id.toString());

    this.filteredRoles.next(this.roles.slice());
    this.commonService.initializeControls(this.filteredRoles, this.rolesFilterControl, this.onDestroy, this.roles);

    this.filteredSalesGroups.next(this.salesGroups.slice());
    this.commonService.initializeControls(this.filteredSalesGroups, this.salesGroupsFilterControl, this.onDestroy,
      this.salesGroups);


    this.filteredDivisions.next(this.divisions.slice());
    this.commonService.initializeControls(this.filteredDivisions, this.divisionsFilterControl, this.onDestroy,
      this.divisions);

    this.filteredUsers.next(this.users.slice());
    this.commonService.initializeControls(this.filteredUsers, this.usersFilterControl, this.onDestroy, this.users);

    this.filteredRegions.next(this.regions.slice());
    this.commonService.initializeControls(this.filteredRegions, this.regionsFilterControl, this.onDestroy, this.regions);

    this.filteredHQs.next(this.hq_ids.slice());
    this.commonService.initializeControls(this.filteredHQs, this.hqsFilterControl, this.onDestroy, this.hq_ids);

    if (this.mode !== 'create') {
      await this.checkRole();
      this.getRepresentativeInfo();
    }

    this.initialized = true;
  }

  public setSalesGroupsMargin(): number {
    if (!this.usersService.showRepresentative(this.userBasicForm) && !this.showStatus()) {
      return 34;
    } else {
      return 0;
    }
  }

  public setStatusMargin(): number {
    if (!this.usersService.showSalesGroup(this.userBasicForm)) {
      return 34;
    } else {
      return 0;
    }
  }

  public isRoleDisabled(): boolean {
    if ((this.userBasicForm.controls.role.value.id === 13 || this.userBasicForm.controls.role.value.id === 14) && this.mode !== 'create') {
      return true;
    }
    if (this.hasChildren) {
      return true;
    } else {
      return this.userBasicForm.value.role.alternate_name === 'salesInspector' || this.userBasicForm.value.role.alternate_name === 'regionalDirector';
    }
  }

  public showStatus(): boolean {
    return this.mode === 'edit';
  }

  isRepresentativeSet(): boolean {
    if ((this.userBasicForm.controls.role.value.id === 13 || this.userBasicForm.controls.role.value.id === 14) && this.mode !== 'create') {
      return true;
    }
    if (this.userBasicForm.controls.representative) {
      return !this.userBasicForm.controls.representative.value;
    } else {
      return false;
    }
  }

  getRepresentativeInfo() {
    try {
      const userInRole = this.userBasicForm.controls.role.value;
      if (userInRole.id === 9 || userInRole.id === 11 || userInRole.id === 12 || userInRole.id === 15 || userInRole.id === 16) {

        if (userInRole.id === 11 || userInRole.id === 15 || userInRole.id === 16) {
          return;
        }
        const selectedUserId = this.userBasicForm.controls.representative.value;
        let selectedUserInfo: any;


        if (userInRole.id === 12) {
          selectedUserInfo = this.technicalManagers.find(user => user.id === selectedUserId);
        } else {
          selectedUserInfo = this.users.find(user => user.id === selectedUserId);
        }

        const selectedUserSalesGroups = selectedUserInfo.sales_group_ids.split(',');
        const groups = [];
        for (const groupId of selectedUserSalesGroups) {
          const tempGroup = this.salesGroups.find(g => g.id === groupId);
          if (tempGroup) {
            groups.push(tempGroup);
          }
        }
        this.filteredSalesGroups.next(groups.slice());
        this.commonService.initializeControls(this.filteredSalesGroups, this.salesGroupsFilterControl, this.onDestroy,
          groups);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  clearRequiredFieldForTechnicians(roleId: number) {
    if (this.initialized) {
      if (roleId === 12) {
        this.userBasicForm.controls.representative.setValue(null);
        this.userBasicForm.controls.salesGroups.setValue(null);
      } else {
        this.userBasicForm.controls.salesGroups.setValue(null);
      }
    }
  }

  async checkForTechnicians() {

    try {
      if (this.userBasicForm.controls.role.value.id === 12 && this.userBasicForm.controls.is_internal.value) {
        this.clearRequiredFieldForTechnicians(12);
        this.technicalManagers = await this.usersService.getUserWithParameters('role_id=11 AND is_internal = 1');

        this.filteredUsers.next(this.technicalManagers.slice());

        this.commonService.initializeControls(this.filteredUsers, this.usersFilterControl, this.onDestroy, this.technicalManagers);
      }

      if (this.userBasicForm.controls.role.value.id === 12 && !this.userBasicForm.controls.is_internal.value) {
        this.clearRequiredFieldForTechnicians(12);
        this.technicalManagers = await this.usersService.getUserWithParameters('role_id=11 AND is_internal = 0');

        this.filteredUsers.next(this.technicalManagers.slice());

        this.commonService.initializeControls(this.filteredUsers, this.usersFilterControl, this.onDestroy, this.technicalManagers);
      }

      if (this.userBasicForm.controls.role.value.id === 11) {
        this.clearRequiredFieldForTechnicians(11);
      }
    } catch (e) {

    }
  }

  async checkRole(status?: boolean) {
    if (status) {
      this.userBasicForm = this.usersService.synchronizeUserBasicForm(this.userBasicForm);
    }
    const userInRole = this.userBasicForm.controls.role.value;

    if (userInRole.id === 12) {
      this.formFieldTitle = 'Τεχνικοί Υπεύθυνοι (*)';
      try {
        await this.checkForTechnicians();
      } catch (e) {
      }

    } else {
      this.formFieldTitle = 'Αντιπρόσωποι (*)';
      this.filteredUsers.next(this.users.slice());

      this.commonService.initializeControls(this.filteredUsers, this.usersFilterControl, this.onDestroy, this.users);
    }
    if (userInRole.id !== 9) {
      this.filteredSalesGroups.next(this.salesGroups.slice());
      this.commonService.initializeControls(this.filteredSalesGroups, this.salesGroupsFilterControl, this.onDestroy,
        this.salesGroups);
    }

    if (userInRole.id === 11) {
      await this.checkForTechnicians();
    }

    if (userInRole.id === 11 || userInRole.id === 15 || userInRole.id === 16 || userInRole.id === 14 || userInRole.id === 18) {
      let installations = [];
      installations = this.salesGroups.filter(sg => sg.category_id === 2);
      this.filteredSalesGroups.next(installations.slice());
      this.commonService.initializeControls(this.filteredSalesGroups, this.salesGroupsFilterControl, this.onDestroy,
        installations);
    }
  }
}
